import React from 'react'
import { Heading } from '@myxplor/ui'
import { startOfWeek, dayFormat } from '../../week'

import { fileNameWithDate } from '../../io/download-csv'
import { validateCCSStartDate } from './helpers'
import { CCSWeekInput } from './ccs-week-input'
import ReportForm from '../views/form'

const onSubmit = ({ gov_id, record_type }) => ({ remote_request }) => payload =>
  remote_request.submit({
    url: `${apiEndPoint({ gov_id, record_type })}?week_start_date=${payload.week_start_date}`,
    method: 'GET',
    fileName: fileNameWithDate('CCS Payments Report'),
  })

const FormFields = ({ values, errors, onChange, valid }) => (
  <fieldset>
    <Heading small>CCS Weekly Payments Report</Heading>
    <CCSWeekInput
      reportName="CCS Payments"
      value={values.week_start_date}
      errors={errors.week_start_date}
      onChange={onChange}
      valid={valid}
    />
  </fieldset>
)

const apiEndPoint = ({ gov_id, record_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${record_type}/${gov_id}/reports/ccs-payments`

export const ReportCCSPayments = ({ gov_id, record_type, resetCurrentReport }) => (
  <ReportForm
    formOptions={{
      validate: validateCCSStartDate,
      defaultValues: {
        week_start_date: dayFormat(startOfWeek()),
      },
    }}
    name="CCS Payments Report"
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
    onSubmit={onSubmit({ gov_id, record_type })}
  />
)



// WEBPACK FOOTER //
// ./src/reports/reports/ccs-payments.jsx